// extracted by mini-css-extract-plugin
export default {"preferencesForm":"SKQ65qEvQc7sVjM99WCg"};